// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1VijZ","selected":"Chip_selected__2s3QU"};